if (typeof customElements.get('shop-the-look-slider') == 'undefined') {
	class ShopTheLook extends HTMLElement {
		constructor() {
			super();

			this.slider = this.querySelector('.splide');
			this.slides = this.slider.querySelectorAll('.splide__slide');
			this.focalPoints = this.querySelectorAll('.shop-the-look-slider__image-point');
			this.sliderPagination = this.querySelectorAll('.splide__pagination__page');
			this.sliderPaginationLength = this.sliderPagination.length;

			this.showPagination = this.slider.dataset.showPagination || true;
			this.classes = {
				activePoint: 'shop-the-look-slider__image-point--active',
			};

			this.init();
		}

		init() {
			this.initSlider();
			this.scrollSliderFromFocalPoint();
		}

		initSlider() {
			if (this.slides.length < 2) return;

			const slider = new Splide(this.slider, {
				type: 'fade',
				perPage: 1,
				drag: true,
				arrows: true,
				pagination: this.showPagination,
				fade: true,
				lazyLoad: 'nearby',
				rewind: true,
			});

			slider.mount();

			slider.on('moved', (event) => {
				this.focalPoints.forEach((focalPoint, index) => {
					if (index === event) {
						focalPoint.classList.add(this.classes.activePoint);
					} else {
						focalPoint.classList.remove(this.classes.activePoint);
					}
				});
			});
		}

		scrollSliderFromFocalPoint() {
			const sliderPagination = this.querySelectorAll('.splide__pagination__page');
			const sliderPaginationLength = sliderPagination.length;

			this.focalPoints.forEach((focalPoint, index) => {
				if (index === 0) {
					focalPoint.classList.add(this.classes.activePoint);
				}

				focalPoint.addEventListener('click', () => {
					const slideIndex = index + 1;
					const slideIndexToScroll = slideIndex > sliderPaginationLength ? 1 : slideIndex;

					sliderPagination[slideIndexToScroll - 1].click();
				});

				focalPoint.addEventListener('touchstart', (event) => {
					event.preventDefault();

					const slideIndex = index + 1;
					const slideIndexToScroll = slideIndex > sliderPaginationLength ? 1 : slideIndex;

					sliderPagination[slideIndexToScroll - 1].click();
				});
			});
		}
	}

	customElements.define('shop-the-look-slider', ShopTheLook);
}
